export default __webpack_public_path__ + "static/media/unchecked.ed960e83.svg";